import actions from './actions';

const state = {
  firstPickupList: [],
};

export default {
  namespaced: true,
  state,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/firstPickup/index.js